import { BASE_PATH_API } from 'constants/env'
import { useState } from 'react'
import { useStore } from 'store'
import { hideLoader, showLoader } from 'store/actions/commons'

const useExternalLinnk = () =>{
    const Domain = BASE_PATH_API
    const [responseProduct, setResponseProducts] = useState(null)
    const [responseError, setResponseError] = useState(null)
    const [ , dispatch ] = useStore((state) => state.giftTable.giftTable)
    
    const getProduct = async (id) => {
        dispatch(showLoader());
        setResponseProducts(null)
        setResponseError(null)
        try{
            const response = await fetch(`${Domain}/products/v1/products?filter_by[id]=${id}`);
            const data = await response.json();
            if(data?.data?.length >= 1){
                setResponseProducts(data?.data)
            }else{
                dispatch(hideLoader());
                setResponseError({
                    statusCode: data?.metadata?.http_status
                })
            }
        } catch (error) {
            dispatch(hideLoader());
            console.error('Error fetching productsFilter data:', error);
        }
    }

    const handleID = (id) => {
        getProduct(id)
    }
    const setResetResponse = () => {
        setResponseProducts(null)
        setResponseError(null)
    }

    return {
        handleID,
        setResetResponse,
        responseProduct,
        responseError
    }
}

export default useExternalLinnk